import { PhoneNumberApi, Configuration } from "@mmc/conferencing-phonenumber-client";

export class PhoneNumberClient {
	readonly phonenumber: PhoneNumberApi;
	constructor(config: Configuration) {
		this.phonenumber = new PhoneNumberApi(config);
	}
}
